import React from 'react';
import styles from './SummaryMetric.module.css';

interface SummaryMetricProps {
  /** Render a dash instead of the value — failed request, unconfigured feature, etc. */
  showDash: boolean;
  isLoading: boolean;
  /** Skeleton class from the caller's CSS module — controls the placeholder width. */
  skeletonClassName: string;
  children: React.ReactNode;
}

export const SummaryMetric: React.FC<SummaryMetricProps> = ({
  showDash,
  isLoading,
  skeletonClassName,
  children,
}) => {
  if (showDash) {
    return <span className={styles.metricDash}>—</span>;
  }
  if (isLoading) {
    return <span className={skeletonClassName} aria-hidden />;
  }
  return <>{children}</>;
};
